import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

import { InputRenderer } from '../types';

const CheckboxInput = ({ inputProps, label }: InputRenderer) => {
  return <FormControlLabel control={<Checkbox checked={inputProps.value} />} label={label} {...inputProps} />;
};

export default CheckboxInput;
